/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Clean_Text_LabelInputs */



/**
* | output |
* | --- |
* | "Clean up text" |
*
* @param {Context_Menu_Clean_Text_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_clean_text_label = /** @type {((inputs?: Context_Menu_Clean_Text_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Clean_Text_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nettoyer le texte")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text bereinigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pulisci il testo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистка текста")
	if (locale === "es") return /** @type {LocalizedString} */ ("Limpiar texto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清理文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを整理する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पाठ को साफ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar texto")
	return /** @type {LocalizedString} */ ("Clean up text")
});